import { Block } from "@components/block";
import { Breadcrumbs } from "@components/breadcrumbs";
import { Table } from "@components/table";
import { useAppeals } from "@features/appeals";
import { merchantAppealConfig } from "@features/appeals/components/disputes/merchant";
import { useBoolState } from "@hooks/use-bool-state";
import { usePagination } from "@hooks/use-pagination";
import { useEffect, useState } from "react";
import { MerchantAppealModal } from "./merchantAppealModal";
import { MergedAppeal } from "@features/appeals/slice";
import { WebsocketUpdateType } from "@request/websocket";
import { useWebSocket } from "@request/useWebsocket";
import { FilterConfig } from "@components/filter-modal";
import { MerchantAppealForm } from "@features/appeals/api";
import { useCashRegisters } from "@features/cash-registers";
import { SelectOption } from "@components/select";
import { useUrlFilters } from "@hooks/useUrlFilters";

export const MerchantDisputesPage = () => {
  return (
    <div>
      <Breadcrumbs items={["Все споры"]} />
      <Appeals />
    </div>
  );
};

const Appeals = () => {
  const { state, getMerchantAppeals } = useAppeals();
  const { page, limit, setPage, setLimit } = usePagination(100);
  const [isModalOpen, showModal, hideModal] = useBoolState(false);
  const [data, setData] = useState<MergedAppeal>();
  const { lastMessage } = useWebSocket();
  const { setParams } = useUrlFilters();

  const [cashOptions, setCashOptions] = useState<SelectOption[]>([]);
  const { state: cacheState, getCashRegisters } = useCashRegisters();

  useEffect(() => {
    getCashRegisters();
  }, [getCashRegisters]);
  useEffect(() => {
    if (cacheState.caches) {
      setCashOptions(
        cacheState.caches.map((cash) => ({ text: cash.name, value: cash.id }))
      );
    }
  }, [cacheState]);
  useEffect(() => {
    if (lastMessage && lastMessage.type == WebsocketUpdateType.Appeal) {
      getMerchantAppeals({ limit, page });
    }
  }, [lastMessage, limit, page]);

  useEffect(() => {
    getMerchantAppeals({ limit, page });
  }, [getMerchantAppeals, limit, page]);

  const onClick = (data: MergedAppeal) => {
    showModal();
    setData(data);
  };
  const filterConfig: FilterConfig<MerchantAppealForm> = [
    {
      type: "select",
      options: [
        { text: "Пересмотрен", value: "approved" },
        { text: "На рассмотрении", value: "pending_support" },
        { text: "Отклонен", value: "canceled" },
      ],
      label: "Статус",
      placeholder: "Статус",
      name: "status",
    },
    {
      type: "select",
      options: cashOptions,
      label: "Касса",
      placeholder: "Касса",
      name: "cash_register",
    },
    {
      type: "select",
      options: [
        { text: "Сделка", value: "pay_in" },
        { text: "Вывод", value: "pay_out" },
      ],
      label: "Тип",
      placeholder: "Тип",
      name: "appeal_type",
    },
  ];

  const onSubmit = (data: MerchantAppealForm) => {
    setParams(data);
    getMerchantAppeals(data);
  };
  return (
    <>
      <Block>
        <Table
          title="Все споры"
          data={state.appeals}
          loading={state.loading}
          config={merchantAppealConfig}
          setPage={setPage}
          setLimit={setLimit}
          page={page}
          limit={limit}
          limits={[100, 200, 300]}
          totalCount={state.totalCount}
          onRowClick={onClick}
          withFilter
          filterProps={{
            filterConfig: filterConfig,
            onSubmit: onSubmit,
          }}
        />
      </Block>
      {data && (
        <MerchantAppealModal
          isOpen={isModalOpen}
          hide={hideModal}
          data={data}
        />
      )}
    </>
  );
};
